/**
 * Is this account eligible for the PARENT BOARD (the Comp Parent Board at
 * /community), the way the rules decide it?
 *
 * shared/firestore.rules' isParentBoardMember() gates its derived branch on
 * an active account that is either free of a studentId or holds a real STAFF
 * role, with no `dancerAccount` claim on the token. So a studentId shuts out
 * a DANCER login, never a staff account. That is the alert's own question
 * (userIsDancerAccount in netlify/functions/lib/communityAccess.mjs), and
 * B13 (audit 2026-10-04, #1305 E1; Bobbie, DECISIONS 99: "Let her read it")
 * is the bug where the two disagreed: a Director, Manager, teacher, front
 * desk or Jr Staff linked to a dancer was alerted about a post she was then
 * refused. A Jr Staff's promoted dancer sign-in carries her email account's
 * exact users-doc shape (role 'ensemble' plus studentId), so she gets the
 * same answer on either sign-in (DECISIONS 26 and 27).
 *
 * KNOWINGLY NOT MODELLED, in the safe direction: the rule's Manage members
 * OVERLAY. A page that needs it composes this with
 * useBoardMembershipEffectiveMember, as ParentBoard.tsx and Search.tsx do.
 *
 * Use this to decide whether to DRAW a door to /community, or to start a
 * listener. It is not a permission: the permission is the rule.
 *
 * Pure, with no Firebase import, so a node test can run it.
 */

/** The five staff roles, the same list as isActiveStaffByDoc() in the rules. */
const STAFF_ROLES = new Set(['director', 'manager', 'company', 'ensemble', 'foh']);

/**
 * @param {{ role?: unknown, studentId?: unknown } | null | undefined} user
 * @returns {boolean}
 */
export function isParentBoardEligibleUserDoc(user) {
  if (!user) return false;
  const linked = typeof user.studentId === 'string' && user.studentId.trim().length > 0;
  return !linked || STAFF_ROLES.has(String(user.role ?? ''));
}
